// extracted by mini-css-extract-plugin
module.exports = {"boxHeight":"Supplier_boxHeight__kPdQh"};